// Safe, client-side demo dataset for unauthenticated previews.
// Contains zero private server database records.
export const DEMO_CASINOS = [
  {
    id: "demo-1",
    casino: "Borgata Hotel Casino & Spa",
    city: "Atlantic City",
    state: "NJ",
    rating: 4.8,
    totalRevenue: 785420000,
    totalSlotWin: 512300000,
    totalSlotHandle: 5629670000,
    totalTableWin: 273120000,
    totalTableDrop: 1345418000,
    totalSlotWinPercent: 9.1,
    totalTableWinPercent: 20.3,
    momChangePercent: 4.6,
    yoyChangePercent: 3.8,
    gameCount: 3120,
    marketShare: "27.2%",
    latestDataYear: 2024,
    yearlyData: [
      { year: 2024, revenue: 785420000 },
      { year: 2023, revenue: 756660000 },
      { year: 2022, revenue: 724100000 },
    ],
  },
  {
    id: "demo-2",
    casino: "Hard Rock Hotel & Casino Atlantic City",
    city: "Atlantic City",
    state: "NJ",
    rating: 4.7,
    totalRevenue: 532100000,
    totalSlotWin: 375400000,
    totalSlotHandle: 4080434000,
    totalTableWin: 156700000,
    totalTableDrop: 833510000,
    totalSlotWinPercent: 9.2,
    totalTableWinPercent: 18.8,
    momChangePercent: -7.4,
    yoyChangePercent: 5.4,
    gameCount: 2450,
    marketShare: "18.4%",
    latestDataYear: 2024,
    yearlyData: [
      { year: 2024, revenue: 532100000 },
      { year: 2023, revenue: 504840000 },
      { year: 2022, revenue: 492300000 },
    ],
  },
  {
    id: "demo-3",
    casino: "Ocean Casino Resort",
    city: "Atlantic City",
    state: "NJ",
    rating: 4.6,
    totalRevenue: 432800000,
    totalSlotWin: 298600000,
    totalSlotHandle: 3078350000,
    totalTableWin: 134200000,
    totalTableDrop: 766857000,
    totalSlotWinPercent: 9.7,
    totalTableWinPercent: 17.5,
    momChangePercent: -14.7,
    yoyChangePercent: 7.2,
    gameCount: 1980,
    marketShare: "15.0%",
    latestDataYear: 2024,
    yearlyData: [
      { year: 2024, revenue: 432800000 },
      { year: 2023, revenue: 403730000 },
      { year: 2022, revenue: 356800000 },
    ],
  },
  // Dummy / Masked records
  {
    id: "demo-locked-4",
    casino: "•••••••• •••••••• Resort",
    city: "••••••••",
    state: "NJ",
    rating: 4.5,
    totalRevenue: 284000000,
    totalSlotWin: 195000000,
    totalSlotHandle: 2074468000,
    totalTableWin: 89000000,
    totalTableDrop: 463541000,
    totalSlotWinPercent: 9.4,
    totalTableWinPercent: 19.2,
    yoyChangePercent: 1.2,
    gameCount: 1650,
    marketShare: "9.8%",
    latestDataYear: 2024,
    isLocked: true,
  },
  {
    id: "demo-locked-5",
    casino: "•••••••• Casino & Hotel",
    city: "••••••••",
    state: "NJ",
    rating: 4.3,
    totalRevenue: 238000000,
    totalSlotWin: 168000000,
    totalTableWin: 70000000,
    totalSlotWinPercent: 70.6,
    totalTableWinPercent: 29.4,
    yoyChangePercent: -2.1,
    gameCount: 1420,
    marketShare: "8.2%",
    latestDataYear: 2024,
    isLocked: true,
  },
  {
    id: "demo-locked-6",
    casino: "•••••• •••••• Casino",
    city: "••••••••",
    state: "NJ",
    rating: 4.2,
    totalRevenue: 192000000,
    totalSlotWin: 142000000,
    totalTableWin: 50000000,
    totalSlotWinPercent: 74.0,
    totalTableWinPercent: 26.0,
    yoyChangePercent: 0.5,
    gameCount: 1200,
    marketShare: "6.6%",
    latestDataYear: 2024,
    isLocked: true,
  },
];
